/*
 * Product page behaviour, ported from the inline scripts in
 * src/pages/products/[slug].astro. Plain ES5-style DOM code with no framework,
 * same as the original — the point of this theme is that the page stays cheap
 * on a low-end phone.
 *
 * The one behavioural addition: selecting a pack also rewrites the hidden
 * variant input, because Shopify's dynamic checkout button posts that form.
 */
(function () {
  var data = window.jvProduct || { variants: [], prepaidDiscount: 100, moneyFormat: '₹{{amount}}' };

  /* ---------- money ---------------------------------------------------- */
  // Shopify keeps money in the smallest unit. Render with the shop's own
  // format so a themed price never disagrees with the cart.
  function money(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var withSeparators = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return data.moneyFormat.indexOf('{{') === -1
      ? '₹' + withSeparators
      : data.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, withSeparators);
  }

  /* ---------- carousel -------------------------------------------------- */
  var carousel = document.getElementById('jv-carousel');
  var thumbs = [].slice.call(document.querySelectorAll('.jv-thumb'));

  function slideWidth() {
    var slide = carousel && carousel.firstElementChild;
    return slide ? slide.getBoundingClientRect().width + 12 : 0;
  }

  function activeIndex() {
    var w = slideWidth();
    return w ? Math.round(carousel.scrollLeft / w) : 0;
  }

  function markThumb(index) {
    thumbs.forEach(function (thumb) {
      thumb.setAttribute('data-on', Number(thumb.getAttribute('data-idx')) === index ? 'true' : 'false');
    });
  }

  function goTo(index) {
    if (!carousel) return;
    var count = carousel.children.length;
    var next = Math.max(0, Math.min(count - 1, index));
    carousel.scrollTo({ left: next * slideWidth(), behavior: 'smooth' });
    markThumb(next);
  }

  if (carousel) {
    // rAF-throttled: scroll fires far more often than the thumbnails need.
    var ticking = false;
    carousel.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        markThumb(activeIndex());
        ticking = false;
      });
    }, { passive: true });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.getAttribute('data-idx')));
      });
    });

    var prev = document.getElementById('jv-carousel-prev');
    var next = document.getElementById('jv-carousel-next');
    if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
  }

  /* ---------- variant selection ----------------------------------------- */
  var pills = [].slice.call(document.querySelectorAll('.jv-variant-pill'));
  var priceEl = document.getElementById('jv-price');
  var mrpEl = document.getElementById('jv-mrp');
  var pctEl = document.getElementById('jv-discount-pct');
  var pillEl = document.getElementById('jv-discount-pill');
  var savingEl = document.getElementById('jv-online-offer-saving');
  var onlinePriceEl = document.getElementById('jv-online-offer-price');
  var variantInput = document.getElementById('jv-selected-variant');

  function selectVariant(pill) {
    // Match on variant id, not element identity: the same packs are rendered
    // twice (hero picker and the "Ready to start?" card), and choosing one has
    // to light up its twin — otherwise the page shows two different packs
    // selected at once.
    var chosenId = pill.getAttribute('data-variant-id');
    pills.forEach(function (other) {
      other.setAttribute('data-selected', other.getAttribute('data-variant-id') === chosenId ? 'true' : 'false');
    });

    var price = Number(pill.getAttribute('data-price')) || 0;
    var mrp = Number(pill.getAttribute('data-mrp')) || 0;
    var prepaid = (Number(pill.getAttribute('data-prepaid-discount')) || 0) * 100;

    if (priceEl) priceEl.textContent = money(price);

    if (mrp > price) {
      if (mrpEl) { mrpEl.textContent = money(mrp); mrpEl.hidden = false; }
      if (pctEl) pctEl.textContent = String(Math.round((1 - price / mrp) * 100));
      if (pillEl) pillEl.hidden = false;
    } else {
      if (mrpEl) mrpEl.hidden = true;
      if (pillEl) pillEl.hidden = true;
    }

    if (savingEl) savingEl.textContent = String(prepaid / 100);
    if (onlinePriceEl) onlinePriceEl.textContent = money(Math.max(price - prepaid, 0));

    // Shopify's payment button submits this form; without it the customer
    // would check out with whichever variant happened to render first. Three
    // forms carry the selection (hero, "Ready to start?", sticky bar), so all
    // of them are kept in step — checking out from the sticky bar must not buy
    // a different pack from the one highlighted.
    var id = pill.getAttribute('data-variant-id');
    if (id) {
      if (variantInput) variantInput.value = id;
      [].slice.call(document.querySelectorAll('.jv-selected-variant-mirror')).forEach(function (input) {
        input.value = id;
      });
    }

    // The "Ready to start?" strapline quotes the prepaid price.
    var readyPrice = document.getElementById('jv-ready-price');
    if (readyPrice) readyPrice.textContent = money(Math.max(price - prepaid, 0));

    // The pay button's sub-line quotes a bare rupee figure (the ₹ is markup),
    // so it is not run through money().
    var rupees = String(Math.round(Math.max(price - prepaid, 0) / 100));
    var payPrice = document.getElementById('jv-hero-online-price');
    if (payPrice) payPrice.textContent = rupees;
    var stickyPrice = document.getElementById('jv-sticky-online-price');
    if (stickyPrice) stickyPrice.textContent = rupees;

    // The sticky bar's gold pill is a status indicator, not just a shortcut:
    // it must read "Selected" whenever the best-value pack is the current one,
    // no matter whether the change came from the pill or the pack picker, and
    // revert when another pack is chosen.
    var offer = document.getElementById('jv-sticky-variant-offer');
    var offerAction = document.getElementById('jv-sticky-variant-action');
    if (offer && offerAction) {
      offerAction.textContent =
        String(offer.getAttribute('data-best-variant-id')) === String(id) ? 'Selected' : 'Tap to select';
    }

    // Releasit reads the selected variant off the product form too, so tell
    // any listening app that the selection moved.
    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { id: id, price: price } }));
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () { selectVariant(pill); });
  });

  // Initialise the pill from whichever pack is selected on load.
  (function initStickyOffer() {
    var current = pills.filter(function (p) { return p.getAttribute('data-selected') === 'true'; })[0];
    var offer = document.getElementById('jv-sticky-variant-offer');
    var offerAction = document.getElementById('jv-sticky-variant-action');
    if (current && offer && offerAction) {
      offerAction.textContent =
        String(offer.getAttribute('data-best-variant-id')) === String(current.getAttribute('data-variant-id'))
          ? 'Selected' : 'Tap to select';
    }
  })();

  /* ---------- reviews carousel ------------------------------------------ */
  var reviews = document.getElementById('jv-reviews');
  if (reviews) {
    var dots = [].slice.call(document.querySelectorAll('#jv-reviews-dots span'));

    function reviewWidth() {
      var card = reviews.firstElementChild;
      return card ? card.getBoundingClientRect().width + 12 : 0;
    }
    function reviewIndex() {
      var w = reviewWidth();
      return w ? Math.round(reviews.scrollLeft / w) : 0;
    }
    function markDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('bg-[#111]', i === index);
        dot.classList.toggle('bg-gray-300', i !== index);
      });
    }
    function goReview(index) {
      var count = reviews.children.length;
      var next = Math.max(0, Math.min(count - 1, index));
      reviews.scrollTo({ left: next * reviewWidth(), behavior: 'smooth' });
      markDot(next);
    }

    var reviewTicking = false;
    reviews.addEventListener('scroll', function () {
      if (reviewTicking) return;
      reviewTicking = true;
      requestAnimationFrame(function () { markDot(reviewIndex()); reviewTicking = false; });
    }, { passive: true });

    var rPrev = document.getElementById('jv-reviews-prev');
    var rNext = document.getElementById('jv-reviews-next');
    if (rPrev) rPrev.addEventListener('click', function () { goReview(reviewIndex() - 1); });
    if (rNext) rNext.addEventListener('click', function () { goReview(reviewIndex() + 1); });
  }

  /* ---------- sticky bottom bar ----------------------------------------- */
  // Revealed once the hero CTAs have scrolled away, so the customer always has
  // a buy action without the bar covering the one already on screen.
  var sticky = document.getElementById('jv-sticky-bar');
  // Trigger off the pack picker where there is one, else the CTA block — the
  // same rule the storefront uses. Never the COD slot: it is empty (and
  // zero-height) until the Releasit app block is placed.
  var stickyTrigger = document.getElementById('jv-variant-selector') || document.getElementById('jv-hero-ctas');
  if (sticky && stickyTrigger) {
    var pageFooter = null;
    function showSticky(show) {
      if (show) {
        sticky.classList.remove('invisible', 'translate-y-full', 'opacity-0', 'pointer-events-none');
        sticky.classList.add('visible', 'translate-y-0', 'opacity-100');
      } else {
        sticky.classList.add('invisible', 'translate-y-full', 'opacity-0', 'pointer-events-none');
        sticky.classList.remove('visible', 'translate-y-0', 'opacity-100');
      }
    }
    var stickyTicking = false;
    function updateSticky() {
      stickyTicking = false;
      if (!pageFooter) pageFooter = document.querySelector('footer');
      // Stand down over the footer, otherwise the bar sits on top of the
      // policy links at the end of the page.
      var footerClear = !pageFooter || pageFooter.getBoundingClientRect().top > window.innerHeight - 8;
      showSticky(stickyTrigger.getBoundingClientRect().bottom < 24 && footerClear);
    }
    window.addEventListener('scroll', function () {
      if (!stickyTicking) { stickyTicking = true; requestAnimationFrame(updateSticky); }
    }, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
  }

  // The gold pill offers the best-value pack; tapping it selects that pack
  // everywhere rather than only relabelling the bar.
  var stickyOffer = document.getElementById('jv-sticky-variant-offer');
  if (stickyOffer) {
    stickyOffer.addEventListener('click', function () {
      var best = stickyOffer.getAttribute('data-best-variant-id');
      var match = pills.filter(function (p) { return p.getAttribute('data-variant-id') === best; })[0];
      if (match) selectVariant(match);
    });
  }

  /* ---------- sticky COD button ----------------------------------------- */
  // Releasit renders a single COD button into the main product form. The sticky
  // bar needs one too, so the original is cloned and clicks are forwarded to it
  // rather than re-implementing the app's form trigger — whatever Releasit binds
  // (its modal, its variant handling) keeps working.
  (function mirrorCodButton() {
    var host = document.getElementById('jv-sticky-cod');
    if (!host) return;

    var attempts = 0;
    var timer = setInterval(function () {
      // Works with either COD app: Releasit renders ._rsi-buy-now-button, EasySell
      // renders .es-popup-button-product. Whichever is installed gets mirrored.
      var source = document.querySelector('#jv-hero-ctas ._rsi-buy-now-button, #jv-hero-ctas .es-popup-button-product');
      // The app injects asynchronously; give it a few seconds, then stop.
      if (!source) { if (++attempts > 40) clearInterval(timer); return; }
      clearInterval(timer);

      var clone = source.cloneNode(true);
      clone.removeAttribute('id');
      clone.classList.add('jv-cod-clone');
      clone.addEventListener('click', function (event) {
        event.preventDefault();
        source.click();
      });
      host.appendChild(clone);
    }, 150);
  })();

  /* ---------- delivery dates -------------------------------------------- */
  // Rendered client-side on purpose: the page is edge-cached for hours, so a
  // server-rendered date would go stale and promise yesterday's delivery.
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  [].slice.call(document.querySelectorAll('.jv-date')).forEach(function (node) {
    var offset = Number(node.getAttribute('data-offset')) || 0;
    var date = new Date();
    date.setDate(date.getDate() + offset);
    node.textContent = date.getDate() + ' ' + MONTHS[date.getMonth()];
  });
})();
